export const getRunID = () => {
  let d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hour = d.getHours(),
    minutes = d.getMinutes(),
    seconds = d.getSeconds();

  if (hour < 10) hour = "0" + hour;
  if (minutes < 10) minutes = "0" + minutes;
  if (seconds < 10) seconds = "0" + seconds;
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  const dateString = [year, month, day].join("-");
  const timeString = [hour, minutes, seconds].join(":");
  return dateString + "_" + timeString;
};
